import { LayoutDashboard } from "lucide-react";
import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HEADER_CONFIG } from "@/src_new/shared/config/header.config";
import {
  getThemeClass,
  getThemeComponentClasses,
} from "@/src_new/shared/lib/themeComponentClasses";
import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import { SiteNavItem } from "./SiteNavItem";
import { App_Url_New } from "../common/static";

function DashboardNavButton() {
  const tableClasses = getThemeComponentClasses().table;
  const navigate = useNavigate();
  const location = useLocation();
  const {
    auth: { customerAuth },
  } = usePosterReducers();

  const accessToken = customerAuth?.access_token || null;
  const dashboardUrl = App_Url_New.retail.frontlinks.retail_dashboard;
  const isDashboardPage = location.pathname === dashboardUrl;

  if (!accessToken || isDashboardPage) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(dashboardUrl)}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm font-semibold transition-all duration-200 ${getThemeClass(tableClasses.controlBorderColor, "border-theme-border-strong/70")} ${getThemeClass(tableClasses.controlBgColor, "bg-theme-text")} ${getThemeClass(tableClasses.controlTextColor, "text-theme-text-inverse")} hover:bg-theme-text/80`}
    >
      <LayoutDashboard className="h-4 w-4 shrink-0" />
      <span>Dashboard</span>
    </button>
  );
}

export function SiteDesktopNav() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const closeTimerRef = useRef<number | null>(null);

  const cancelClose = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimerRef.current = window.setTimeout(() => {
      setActiveMenu(null);
    }, 140);
  };

  return (
    <nav className="hidden items-center gap-6 lg:flex">
      <DashboardNavButton />

      {HEADER_CONFIG.navigation.map((item) => (
        <SiteNavItem
          key={item.label}
          item={item}
          activeMenu={activeMenu}
          onOpen={setActiveMenu}
          onScheduleClose={scheduleClose}
          onCancelClose={cancelClose}
        />
      ))}
    </nav>
  );
}
